<template>
  <div class="head">
    <div class="wrapper top">
      <img class="logo" src="../../../static/images/top_logo.png" @click="goToIndex"/>
      <div class="middle">
        <ul>
          <li v-for="(item, index) in navList" :key="item.key" @click="navClick(item.key)"
              :class="$route.path.indexOf(item.key) > -1?'active':''">{{ item.name }}
          </li>
        </ul>
        <div class="search">
          <input type="text" placeholder='搜索支持空格，例如: "音乐  财经"' v-model="searchContent"/>
          <button @click="search">搜索</button>
        </div>
      </div>
      <button class="login" @click="login" v-if="!isLogin">登录</button>
      <div class="user-info" v-else>
        <div class="avatar">
          <img :src="user_info.headimgUrl"/>
          <span>{{user_info.nickname}}</span>
        </div>
        <ul class="set-list">
          <li @click="personal" :class="$route.name == 'my'?'active':''">个人中心</li>
          <li @click="loginOut">退出登录</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import {logout} from '../../network/api'
import { mapGetters } from 'vuex'
import {Toast} from "vant";

export default {
  name: "headMenu",
  data() {
    return {
      navList: [{
        key: 'index',
        name: '首页'
      }, {
        key: 'article',
        name: '文章'
      }, {
        key: 'college',
        name: '学院'
      }, {
        key: 'vip',
        name: '升级VIP'
      }],
      searchContent: ''
    }
  },
  computed: {
    ...mapGetters([
      'isLogin',
      'user_info'
    ])
  },
  watch: {
    isLogin(newValue, oldValue) {
      console.log(oldValue)
      console.log(newValue)
    },
    user_info(newValue, oldValue) {
      console.log(oldValue)
      console.log(newValue)
    }
  },
  methods: {
    goToIndex() {
      console.log(this.$route)
      if(this.$route.name != 'index') {
        this.$router.push({
          name: 'index'
        })
      }

    },
    navClick(name) {
      this.$router.push({
        name: name
      })
    },
    personal() {
      this.$router.push({
        name: 'my'
      })
    },
    search() {
      if(!window.localStorage.getItem("token")) {
        this.$emit('login')
      } else {
        this.$router.push({
          name: 'search',
          query: {
            searchContent: this.searchContent
          }
        })
      }

    },
    login() {
      this.$emit('login')
    },
    loginOut() {
      logout().then(() => {
        Toast('退出登录成功')
        this.goToIndex()
        window.localStorage.removeItem("token")
        this.$store.dispatch('user/changeLoginStatus',false)
      })
    }
  }

}
</script>

<style scoped lang="less">
.head {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 80px;
  line-height: 80px;
  background: #ffffff;
  z-index: 40;

  .top {
    display: flex;
    flex-direction: row;
    align-items: center;

    .logo {
      /*width: 100px;*/
      height: 42px;
      cursor: pointer;
    }

    .middle {
      flex: 1;
      display: flex;
      flex-direction: row;

      ul {
        display: flex;
        flex-direction: row;
        margin-left: 105px;
        font-size: 16px;

        li {
          margin-right: 66px;
          cursor: pointer;

          &.active {
            font-size: 16px;
            color: #E70012;
          }

          &:last-child {
            margin-right: 0;
          }
        }
      }
    }

    .search {
      display: flex;
      flex-direction: row;
      margin-left: 154px;
      margin-top: 22px;

      input {
        width: 250px;
        height: 40px;
        line-height: 40px;
        background: #FFFFFF;
        border: 1px solid #999999;
        text-indent: 10px;
        font-size: 14px;
      }

      button {
        width: 60px;
        height: 40px;
        line-height: 40px;
        background: #333333;
        color: #ffffff;
        cursor: pointer;
        font-size: 14px;
      }
    }

    .login {
      width: 80px;
      height: 40px;
      line-height: 40px;
      background: #E70012;
      color: #FFFFFF;
      cursor: pointer;
      font-size: 14px;
    }

    .user-info {
      position: relative;
      cursor: pointer;

      img {
        width: 40px;
        height: 40px;
        margin-right: 5px;
        vertical-align: middle;
      }

      span {
        font-weight: 600;
      }

      &:hover .set-list {
        height: 80px;
      }

      .set-list {
        position: absolute;
        left: 0;
        top: 80px;
        width: 80px;
        height: 0;
        overflow: hidden;
        padding: 0 10px;
        background: #FFFFFF;
        box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
        transition: 1s;
        font-size: 14px;
        z-index: 41;

        li {
          color: #666666;
          height: 40px;
          line-height: 40px;
          text-align: center;
          border-bottom: 1px solid #EEEEEE;
           z-index: 41;

          &:last-child {
            border-bottom: none;
          }

          &:hover, &.active {
            color: #E70012;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/header/header.vue